import { Component, computed, signal } from '@angular/core';
import { TaxonomyService } from '../../../services/taxonomy.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { Router } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-taxonomy-list',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    CommonModule,
    FormsModule,
    MatMenuModule,
    MatButtonModule,
    MatInputModule,
  ],
  templateUrl: './taxonomy-list.component.html',
  styleUrl: './taxonomy-list.component.scss',
})
export class TaxonomyListComponent {
  searchText = signal<string>('');
  options = computed(() => this.taxonomyService._list_of_taxonomies());

  filteredOptions = computed(() => {
    const search = this.searchText().toLowerCase();
    return this.options().filter((option) => option.taxonomy_name.toLowerCase().includes(search));
  });

  _selectedValue = this.taxonomyService.getSelectedValue();
  taxoSelectedValue = computed(() => this._selectedValue()?.taxonomy_name || 'Select Taxonomy');

  constructor(
    public taxonomyService: TaxonomyService,
    private router: Router
  ) {}

  onSelectionChange(value: string) {
    const selected = this.options().find((option) => option.taxonomy_id === value) || null;
    this.taxonomyService.setSelectedValue(selected);
  }
}
